import { createSelector } from "reselect";

const products = {};

/**
 * Returns all products.
 * @param {Object} state
 * @returns {Object[]} products
 */
products.get = state => state.products.items;

/**
 * Returns uri of current product.
 * @param {Object} state
 * @returns {string} uri
 */
products.getCurrentUri = state => state.products.current;

/**
 * Return all products except self-referential 'Canonical RBAC service' product.
 * @param {object} state
 * @returns {Object[]} products
 */
products.getFiltered = createSelector(
  [products.get],
  products =>
    products.filter(product => product.$uri !== "/api/rbac/v1/product/1")
);

/**
 * Return self-referential 'Canonical RBAC service' product.
 * @param {object} state
 * @returns {Object} product
 */
products.getRbac = createSelector(
  [products.get],
  products =>
    products.find(product => product.$uri === "/api/rbac/v1/product/1")
);

/**
 * Return current product object
 * @param {object} state
 * @returns {Object} product
 */
products.getCurrent = createSelector(
  [products.getCurrentUri, products.getFiltered],
  (currentProductUri, products) =>
    products.find(product => product.$uri === currentProductUri)
);

export default products;
